import { Link } from "react-router-dom";
import { Button } from "../ui/button";

const homeFeatures = [
  {
    title: "Fresh from the Sea",
    desc: "Grilled barramundi finished with honey mustard, flame-grilled smoked bacon oysters, semolina-dusted salt and pepper calamari and our signature sizzling garlic king prawns — coastal cooking is the heart of everything we do."
  },
  {
    title: "From Breakfast Till Late",
    desc: "Start the day with buttermilk pancakes, eggs benedict on a butter croissant or our famous Big Breakfast, and come back for handmade pastas, burgers, schnitzels and slow-cooked classics by night."
  },
  {
    title: "The Licensed Bar",
    desc: "Crafted cocktails, Australian and international beers, a considered whisky collection and a wine list that runs from house favourites to French Champagne. Mocktails and zero-alcohol options mean every guest raises a glass."
  }
];

export default function AboutSection() {
  return (
    <section className="relative bg-cream py-24 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          {/* Image */}
          <div className="relative">
            <div className="absolute -top-6 -left-6 w-32 h-32 border-2 border-spice-gold hidden lg:block" />
            <div className="relative overflow-hidden">
              <img
                src="/image/siteimages/gallery/restaurantPhotos/Photo%203.png"
                alt="Sea Spice Kitchen coastal fusion dishes"
                className="w-full h-[520px] object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-sea-deep text-white px-8 py-6 hidden lg:block">
              <div className="font-display text-4xl text-spice-gold">2026</div>
              <div className="text-xs tracking-[0.25em] uppercase mt-1">Est. Frankston</div>
            </div>
          </div>

          {/* Copy */}
          <div>
            <span className="divider-ornament">Our Story</span>
            <h2 className="font-display text-sea-deep text-4xl md:text-5xl lg:text-6xl font-medium leading-[1.1] mt-5 mb-6">
              Cafe, restaurant and <em className="text-spice-gold font-light">licensed bar</em>
            </h2>
            <p className="text-sea-mid/85 text-base md:text-lg leading-relaxed mb-5">
              Perched on the Nepean Highway just minutes from the bay, Sea Spice Kitchen is Frankston&apos;s
              home of coastal fusion dining. We are a cafe, restaurant and fully licensed bar under one roof.
            </p>
            <p className="text-sea-mid/85 text-base leading-relaxed mb-8">
              Our kitchen celebrates the freshest catch alongside the dishes families love: golden schnitzels crumbed fresh each day, handmade pastas, slow-cooked ribs, hearty heritage curries and a breakfast menu worth setting an alarm for. Whether you are dropping in for coffee and pancakes, gathering the family for dinner, or settling in at the bar with a glass from our curated wine list, our table is set for you.
            </p>

            {/* Points */}
            <div className="grid grid-cols-1 gap-5 mb-10">
              {homeFeatures.map((p) => (
                <div key={p.title} className="flex gap-3">
                  <div className="w-1.5 h-1.5 rounded-full bg-spice-gold mt-2 flex-shrink-0" />
                  <div>
                    <div className="font-display text-sea-deep text-lg">{p.title}</div>
                    <div className="text-sea-mid/75 text-sm leading-relaxed">{p.desc}</div>
                  </div>
                </div>
              ))}
            </div>

            <Link to="/about">
              <Button className="bg-sea-deep hover:bg-[hsl(184_60%_10%)] text-white rounded-none px-8 h-12 tracking-wide">
                Discover More
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
